module.exports = __webpack_public_path__ + "5f0336b4ea9af9a6c05527569cbe12e9.svg";